#version 300 es
precision mediump float;
uniform sampler2D uScene;
uniform sampler2D uBloom;
uniform float uBloomStrength;   // 0–1, additive bloom intensity
uniform float uMotionBlur;      // 0–1, how much radial blur to apply
in vec2 vUV;
out vec4 fragColor;

void main() {
  // Motion blur: radial zoom samples diverging from screen centre.
  // Models forward motion in a chase/cockpit camera (optic flow expands from centre).
  // At rest (uMotionBlur ~ 0) every tap collapses to the same texel, so skip the
  // loop entirely — one fetch instead of 8. Uniform control flow (no per-pixel
  // divergence); saves 7/8 of the composite texture bandwidth whenever the car
  // is stationary or slow — exactly the idle web-health probe state.
  const int MB_TAPS = 8;
  vec3 scene;
  if (uMotionBlur < 0.0008) {
    scene = texture(uScene, vUV).rgb;
  } else {
    vec2 dir = vUV - vec2(0.5); // direction outward from centre
    scene = vec3(0.0);
    for (int i = 0; i < MB_TAPS; i++) {
      float t = float(i) / float(MB_TAPS - 1);
      vec2 uv = clamp(vUV + dir * t * uMotionBlur, vec2(0.0), vec2(1.0));
      scene += texture(uScene, uv).rgb;
    }
    scene /= float(MB_TAPS);
  }

  // Additive bloom
  vec3 bloom = texture(uBloom, vUV).rgb;
  vec3 color = scene + bloom * uBloomStrength;

  fragColor = vec4(color, 1.0);
}
